import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Tag } from 'primereact/tag';
import { Calendar } from 'primereact/calendar';
import { useHistory } from 'react-router-dom';

import api from './../../service/api';
import { formatCurrency } from '../../service/format';
import { getAuthData, isAdmin } from '../../service/auth';
import { downloadCsv } from '../../service/handle';
import InputDecimal from '../../components/InputDecimal';

const Travel = () => {
    var startDate = new Date();
    if(!window.localStorage.getItem('@ctruckFilterStartDate')){
        startDate.setDate(1);
        window.localStorage.setItem('@ctruckFilterStartDate', startDate.getTime());
    } else startDate = new Date(parseInt(window.localStorage.getItem('@ctruckFilterStartDate')));

    var endDate = new Date();
    if(!window.localStorage.getItem('@ctruckFilterEndDate')){
        endDate.setMonth(endDate.getMonth() + 1);
        window.localStorage.setItem('@ctruckFilterEndDate', endDate.getTime());
    } else endDate = new Date(parseInt(window.localStorage.getItem('@ctruckFilterEndDate')));

    let emptyTravel = {
        description: '',
        truck: null,
        driver: null,
        product: '',
        amount_ton: null,
        quantity_ton: null,
        status: null
    };

    var driverCode = parseInt(window.localStorage.getItem('@ctruckFilterDriver') || 0);
    let emptyFilter = {
        startDate: startDate,
        endDate: endDate,
        driver: driverCode || 'all',
        status: window.localStorage.getItem('@ctruckFilterStatus') || 'all',
        typeDate: window.localStorage.getItem('@ctruckFilterTypeDate') || 'travel.createdat'
    }
    
    const [travels, setTravels] = useState([]);
    const [drivers, setDrivers] = useState([]);
    const [trucks, setTrucks] = useState([]);
    const [filter, setFilter] = useState(emptyFilter);
    const [filterStatus] = useState('all');
    const [travelDialog, setTravelDialog] = useState(false);
    const [travel, setTravel] = useState(emptyTravel);
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [loading, setLoading] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const toast = useRef(null);
    const dt = useRef(null);
    const isadmin = isAdmin();
    const authData = getAuthData();
    const filters = [
        { label: 'Todas', value: 'all' },
        { label: 'Pendentes', value: 'pending' },
        { label: 'Em andamento', value: 'processing' },
        { label: 'Concluídas', value: 'done' },
        { label: 'Em análise', value: 'analyze' },
        { label: 'Canceladas', value: 'canceled' }
    ]
    const statusTranslated = {
        'pending': <Tag severity='warning'>Pendente</Tag>,
        'processing': <Tag style={{ whiteSpace: 'nowrap' }} severity='info'>Em andamento</Tag>,
        'canceled': <Tag severity='danger'>Cancelada</Tag>,
        'analyze': <Tag severity='primary'>Em análise</Tag>,
        'done': <Tag severity='success'>Concluída</Tag>
    };
    const filterTypeDate = [
        { label: 'Data de Criação', value: 'travel.createdat' },
        { label: 'Data de Início da Viagem', value: 'travel.started' },
        { label: 'Data de Finalização da Viagem', value: 'travel.completed' }
    ];
    const history = useHistory();

    const onInputChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _travel = { ...travel };
        _travel[`${name}`] = val;

        setTravel(_travel);
    }

    function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const onInputFilterChange = (e, name) => {
        const val = (e.target && e.target.value) || (e.value) || '';
        let _filter = { ...filter };
        _filter[`${name}`] = val;

        window.localStorage.setItem(`@ctruckFilter${capitalizeFirstLetter(name)}`, typeof val == 'object' ? val.getTime() : val)

        setFilter(_filter);
    }

    const openNew = () => {
        setTravel(emptyTravel);
        setSubmitted(false);
        setTravelDialog(true);
        setDisabled(false);
    }

    const hideDialog = () => {
        setSubmitted(false);
        setTravelDialog(false);
        setDisabled(false);
    }

    const handleTravel = () => {
        if(!travel.truck || (!travel.driver && isadmin) || !travel.amount_ton
            || !travel.product || !travel.quantity_ton)
                return setSubmitted(true);
        
        setSubmitted(false);
        setDisabled(true);

        var _travel = {...travel};

        if(!isadmin) _travel['driver'] = authData.user.identifier;

        api().post('/travel/create', _travel).then(response => {
            if(response.status === 200 && response.data.result){
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listTravels(filterStatus);
                hideDialog();
            } else {
                toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                setDisabled(false);
            }
        });
    }

    const handleDelete = () => {
        setDeleteDialog(false);
        api().delete('/travel/' + travel.code).then(response => {
            if(response.status === 200 && response.data.result) {
                toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                listTravels();
            } else toast.current.show({severity: 'error', summary: 'Erro', detail: response.data.message});
            setTravel(emptyTravel);
        });
    }

    const confirmDelete = (_travel) => {
        setTravel({ ..._travel });
        setDeleteDialog(true);
    }

    const listTravels = () => {
        setLoading(true);
        var filtersRequest = {...filter};

        if(filter.startDate) {
            let date = new Date(filter.startDate)
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            filtersRequest['startDate'] = date.getTime();
        }
        if(filter.endDate) {
            let date = new Date(filter.endDate)
            date.setHours(23);
            date.setMinutes(59);
            date.setSeconds(59);
            filtersRequest['endDate'] = date.getTime();
        }
        if(!isadmin) filtersRequest['driver'] = authData.user.identifier;

        api().post('/travel/list', filtersRequest).then(response => {
            if(response.status === 200 && response.data.result){
                setTravels(response.data.data);
            }
            setLoading(false);
        });
    }

    const listTrucks = () => {
        api().get('truck/list').then(response => {
            if(response.status === 200 && response.data.result){
                setTrucks(response.data.data);
            }
        });
    }

    const listDrivers = () => {
        api().get('/driver/list').then(response => {
            if(response.status === 200 && response.data.result){
                setDrivers(response.data.data);
            }
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="Nova" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        )
    }

    const header = (
        <div className="">
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center mb-6">
                <h5 className="m-0">Viagens</h5>
                <span className="block p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" style={{ width: "100%" }} onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar..." />
                </span>
            </div>
            
            <div className="grid">
                <div className="field mt-2 lg:col-4 sm:col-6">
                    <span className="p-float-label">
                        <Calendar value={filter.startDate} style={{ width: "100%" }} onChange={(e) => onInputFilterChange(e, 'startDate')} dateFormat='dd/mm/yy' locale='pt-br' />
                        <label>Data Inicial</label>
                    </span>
                </div>
                <div className="field mt-2 lg:col-4 sm:col-6">
                    <span className="p-float-label">
                        <Calendar value={filter.endDate} style={{ width: "100%" }} onChange={(e) => onInputFilterChange(e, 'endDate')} dateFormat='dd/mm/yy' locale='pt-br' />
                        <label>Data Final</label>
                    </span>
                </div>
                <div className="field mt-2 lg:col-4 sm:col-6">
                    <span className="p-float-label">
                        <Dropdown value={filter.status} id="truckFilter" style={{ width: "100%" }} options={filters} onChange={(e) => {
                            onInputFilterChange(e, 'status');
                        }} optionLabel="label" optionValue='value' placeholder="Selecione uma situação" />
                        <label>Situação</label>
                    </span>
                </div>
                {isadmin ? (
                    <div className="field lg:col-4 sm:col-6 mt-2">
                        <span className="p-float-label">
                            <Dropdown value={filter.driver} id="driverFilter" style={{ width: "100%" }} options={[{ name: "Todos", code:"all" }].concat(drivers)} onChange={(e) => onInputFilterChange(e, 'driver')} optionLabel="name" optionValue='code' placeholder="Selecione o motorista" />
                            <label htmlFor='driverFilter'>Motorista</label>
                        </span>
                    </div>
                ) : ''}
                <div className="field mt-2 lg:col-4 sm:col-6">
                    <span className="p-float-label">
                        <Dropdown value={filter.typeDate} id="typeDateFilter" style={{ width: "100%" }} options={filterTypeDate} onChange={(e) => {
                            onInputFilterChange(e, 'typeDate');
                        }} optionLabel="label" optionValue='value' placeholder="Selecione um tipo de data" />
                        <label>Tipo Data</label>
                    </span>
                </div>
            </div>
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
                <div className="field col">
                    <Button label="Filtrar" onClick={listTravels} style={{ float: "right" }} icon="pi pi-filter" className="p-button-info" />
                </div>
            </div>
        </div>
    );

    const productDialogFooter = (
        <>
            <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={hideDialog} />
            <Button label="Salvar" onClick={handleTravel} loading={disabled} icon="pi pi-check" className="p-button-text"  />
        </>
    );

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-trash" className="p-button-rounded p-button-danger mr-2" onClick={() => confirmDelete(rowData)} />
                <Button icon="pi pi-ellipsis-v" className="p-button-rounded p-button-info mr-2" onClick={() => {
                    history.push('travel/detail/' + rowData.code);
                }} />
            </div>
        );
    }

    const deleteDialogFooter = (
        <>
            <Button label="Não" icon="pi pi-times" className="p-button-text" onClick={() => setDeleteDialog(false)} />
            <Button label="Sim" icon="pi pi-check" className="p-button-text" onClick={handleDelete} />
        </>
    );

    const [loadingExport, setLoadingExport] = useState(false);
    const rightButton = () => (
        <>
            <Button label="Exportar" icon="pi pi-download" loading={loadingExport} className="p-button-text" onClick={() => {
                setLoadingExport(true);
                downloadCsv(['Número', 'Descrição', 'Motorista', 'Caminhão', 'Produto', 'Quantidade (Ton)', 
            'Valor por Tonelada', 'Total Bruto', 'Comissão Motorista', 'Porcentagem Comissão', 'Vale Motorista',  'Total Despesa', 'Valor Depositado', 'Vale Caminhão', 'Adiantamento', 'Km (Inicial)', 'Km (Final)', 'Data (Inicial)', 'Data (Final)'], travels.map(data => {
                    var dateOptions = {
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                    }
                    return [
                        String(data.code).padStart(4, '0'),
                        data.description,
                        data.driverName,
                        data.plate.toUpperCase(),
                        data.product,
                        formatCurrency(data.quantity_ton),
                        formatCurrency(data.amount_ton),
                        formatCurrency(data.quantity_ton * data.amount_ton),
                        formatCurrency(data.quantity_ton * data.amount_ton * data.commission_percentage * 0.01),
                        formatCurrency(data.commission_percentage || 0),
                        formatCurrency(data.voucher || 0),
                        formatCurrency(data.expense_total_amount || 0),
                        formatCurrency(data.deposit || 0),
                        formatCurrency(data.voucher_truck || 0),
                        formatCurrency(data.advance || 0),
                        data.kilometer_initial,
                        data.kilometer_final,
                        data.started ? new Date(data.started).toLocaleDateString('pt-br', dateOptions) : '-',
                        data.completed ? new Date(data.completed).toLocaleDateString('pt-br', dateOptions) : '-',
                    ];
                }), 'Viagem_' + Date.now());
                setTimeout(() => {
                    setLoadingExport(false)
                }, 3000);
            }} />
        </>
    );
   
    useEffect(() => {
        listTravels();
        listTrucks();
        listDrivers();
    }, []);
  
    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <Toast ref={toast} />
                    <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightButton}></Toolbar>

                    <DataTable ref={dt} value={travels} loading={loading}
                        dataKey="id" paginator rows={10} rowsPerPageOptions={[5, 10, 25]} className="datatable-responsive"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Listando {first} a {last} de {totalRecords} registros"
                        globalFilter={globalFilter} emptyMessage="Nenhum registro encontrado." header={header} responsiveLayout="scroll">
                        <Column body={rowData => String(rowData.code).padStart(4, '0')} header="Nº"></Column>
                        <Column field="description" header="Descrição"></Column>
                        <Column field="driverName"  header="Motorista" sortable></Column>
                        <Column field="plate" header="Caminhão"></Column>
                        <Column field="product" header="Produto" sortable></Column>
                        <Column field="quantity_ton" header="QTD. (Ton)" body={rowData => formatCurrency(rowData.quantity_ton || 0)}></Column>
                        <Column field="amount_ton" body={rowData => formatCurrency(rowData.amount_ton || 0, true)} header="Valor por Ton."></Column>
                        <Column body={rowData => formatCurrency(rowData.amount_ton * rowData.quantity_ton, true)} header="Total Bruto"></Column>
                        <Column field="status" body={rowData => statusTranslated[rowData.status] || '-'} style={{ whiteSpace: 'nowrap' }} header="Situação"></Column>
                        <Column body={actionBodyTemplate} style={{ whiteSpace: 'nowrap' }}></Column>
                    </DataTable>

                    <Dialog visible={travelDialog} style={{ width: '450px' }} header="Viagem" modal className="p-fluid" footer={productDialogFooter} onHide={hideDialog}>
                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor="description">Descrição</label>
                                <InputText disabled={disabled} id="description" required autoFocus  value={travel.description}  onChange={(e) => onInputChange(e, 'description')} />
                                {submitted && !travel.description && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                            </div>
                        </div>
                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor="product">Produto</label>
                                <InputText disabled={disabled} id="product" required value={travel.product}  onChange={(e) => onInputChange(e, 'product')} />
                                {submitted && !travel.product && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                            </div>
                        </div>
                        <div className="formgrid grid">
                            <div className="field col">
                                <label htmlFor="amount_ton">Valor por Tonelada</label>
                                <InputDecimal disabled={disabled} id="amount_ton" value={travel.amount_ton} mode='currency' onChange={(e) => onInputChange(e, 'amount_ton')} />
                                {submitted && !travel.amount_ton && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                            </div>
                            <div className="field col">
                                <label htmlFor="quantity_ton">Quantidade (Ton)</label>
                                <InputDecimal disabled={disabled} id="quantity_ton" maxFractionDigits={3}  mode='decimal' value={travel.quantity_ton} onChange={(e) => onInputChange(e, 'quantity_ton')}  />
                                {submitted && !travel.quantity_ton && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                            </div>
                        </div>

                        <div className='formgrid grid'>
                            <div className="field col">
                                <label htmlFor='truck'>Caminhão</label>
                                <Dropdown value={travel.truck} id="truck" options={trucks} onChange={(e) => onInputChange(e, 'truck')} optionLabel="plate" optionValue='code' placeholder="Selecione o caminhão" />
                                {submitted && !travel.truck && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                            </div>
                        </div>
                        {isadmin ? (
                            <div className='formgrid grid'>
                                <div className="field col">
                                    <label htmlFor='driver'>Motorista</label>
                                    <Dropdown value={travel.driver} id="driver" options={drivers} onChange={(e) => onInputChange(e, 'driver')} optionLabel="name" optionValue='code' placeholder="Selecione o motorista" />
                                    {submitted && !travel.driver && <small className="p-invalid p-error">Preencha este campo para continuar.</small>}
                                </div>
                            </div>
                        ) : <></>}
                    </Dialog>

                    <Dialog visible={deleteDialog} style={{ width: '450px' }} header="Atenção" modal footer={deleteDialogFooter} onHide={() => setDeleteDialog(false)}>
                        <div className="flex align-items-center justify-content-center">
                            <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                            {travel && <span>Você tem certeza que deseja remover esta viagem?</span>}
                        </div>
                    </Dialog>
                </div>
            </div>
        </div>
    );
}

export default Travel;